import { combineReducers } from 'redux';

import { editSchedulerReducer } from './edit/store/editScheduler.reducer';

export const maintenanceStandardSchedulerReducer = combineReducers({
    edit: editSchedulerReducer,
});
